import { render, staticRenderFns } from "./DTxDiagTreatmentPage.vue?vue&type=template&id=58a53be7"
import script from "./DTxDiagTreatmentPage.vue?vue&type=script&lang=js"
export * from "./DTxDiagTreatmentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports